import React, { useEffect, useState } from "react";
import socket from "../../assets/socketConnection";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  ProcessAlertContStyled,
  RightColor,
  AlertText,
} from "./processAlert.styles";
import { selectCurrentReqInfo } from "../../redux/currentReq/currentReq.selectors";
const ProcessAlert = ({ selectCurrentReqInfo }) => {
  const [alertData, setAlertData] = useState();
  const { _id, status } = selectCurrentReqInfo;
  console.log("pp", alertData);
  useEffect(() => {
    socket.emit("get_load_process_message", {
      load_id: _id,
      status: status,
      target: "member",
    });
    socket.on("response_load_process_message", (data) => {
      setAlertData(data);
      console.log(typeof data[0].color);
    });
  }, [_id, status]);

  return (
    <>
      {alertData
        ? alertData.map((data) => (
            <ProcessAlertContStyled color={data?.color}>
              <RightColor color={data?.color}>
                {data?.color === "red" ? "!" : "✓"}
              </RightColor>
              <AlertText>{data?.message}</AlertText>
            </ProcessAlertContStyled>
          ))
        : ""}
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  selectCurrentReqInfo: selectCurrentReqInfo,
});

export default connect(mapStateToProps)(ProcessAlert);
